import Environment from "./environment";

export const sendPhoto = async (file: File|string, accessToken: string): Promise<string | null> => {
    
    if (file instanceof File) {
      const formData = new FormData();
      formData.append('file', file);
  
      try {
        console.log("MANDOU")
        const response = await fetch(`${Environment.VITE_API_URL}/api/v1/upload-image`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: 'include',
          body: formData,
        });
  
        if (response.ok) {
          const data = await response.json();
          return data.image_url; // Retorna apenas a URL da imagem
        }
      } catch (error) {
        console.error('Erro ao enviar imagem', error);
      }
    }
  
    return null;
  };